import { observer } from "mobx-react";
import ControlGroupWithPreview from "../../../../../../components/layouts/control-group-with-preview/control-group-with-preview";
import ListLayout from "../../../../../../components/layouts/list-layout/list-layout";
import { FormField } from "../../../../../../components/form-field/form-field";
import TranslationInput from "../../../../../../translation/translation-input/translation-input";
import { RETURNS_PORTAL_TRANSLATION_KEYS } from "../../constants";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import { useEffect } from "react";
import { IReturnPortalErrorScope } from "./product-exchange-editor-page";
import ExchangeProduct5Preview from '../../../../../../images/previews/product-exchange-5.svg';

export interface ITranslationMethodsProps {
    onTranslationMethodsReady: (scope: IReturnPortalErrorScope) => void;
}

const ReturnPortalErros: React.FC<ITranslationMethodsProps> = observer(({ onTranslationMethodsReady }) => {
    const { hasChanges, save, discardChanges } = useTranslation();

    useEffect(() => {
        onTranslationMethodsReady({
            hasChanges, save, discardChanges
        });
    }, [onTranslationMethodsReady, save, hasChanges, discardChanges]);

    return (
        <ControlGroupWithPreview preview={<img src={ExchangeProduct5Preview} alt="" />}>
            <ListLayout>
                <FormField label="Search Error">
                    <TranslationInput translationKey={RETURNS_PORTAL_TRANSLATION_KEYS.SEARCH_ERROR} />
                </FormField>

                <FormField label="Search Error Icon">
                    <TranslationInput translationKey={RETURNS_PORTAL_TRANSLATION_KEYS.SEARCH_ERROR_ICON} />
                </FormField>

                <FormField label="Search Error Try Again">
                    <TranslationInput translationKey={RETURNS_PORTAL_TRANSLATION_KEYS.SEARCH_ERROR_TRY_AGAIN} />
                </FormField>
            </ListLayout>
        </ControlGroupWithPreview>
    );
});

export default ReturnPortalErros;